/**
 * inputUiInfo marker written when the user declines the write-preview test:
 * the step is configured and must not be offered for testing again.
 */
export const AI_BUILDER_TEST_SKIPPED = 'aiBuilderTestSkipped'
/** inputUiInfo marker: the LLM fill ran for this step — leftover empty
 * optional fields are deliberate, never re-fill on every turn */
export const AI_BUILDER_FILL_COMPLETED = 'aiBuilderFillCompleted'
/**
 * inputUiInfo map, prop name → the words the user named the target with
 * ("gitlab"), recorded by the agent's tools. Dropdown options only resolve
 * later (after the connection, often on another turn): the hint is what the
 * choice is matched against then, never the whole request.
 */
export const AI_BUILDER_SELECTION_HINTS = 'aiBuilderSelectionHints'
